"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elevations = exports.intPointsSet3D = exports.intPoint3D = exports.intRectangle = exports.pointsToString2D = exports.intPointsSet2D = exports.intPoint2D = void 0;
const numbers_1 = require("../numbers");
function intPoint2D({ xMinInt, xMaxInt, yMinInt, yMaxInt }) {
    const x = (0, numbers_1.integerBetween)({ minInt: xMinInt, maxInt: xMaxInt });
    const y = (0, numbers_1.integerBetween)({ minInt: yMinInt, maxInt: yMaxInt });
    return { x, y };
}
exports.intPoint2D = intPoint2D;
function intPointsSet2D({ xMinInt, xMaxInt, yMinInt, yMaxInt, numPoints }) {
    const n = Math.min((xMaxInt - xMinInt + 1) * (yMaxInt - yMinInt + 1), numPoints);
    const points = new Set();
    while (points.size < n) {
        const point = intPoint2D({ xMinInt, xMaxInt, yMinInt, yMaxInt });
        if ([...points].findIndex((p) => p.x === point.x && p.y === point.y) === -1) {
            points.add(point);
        }
    }
    return [...points].sort((a, b) => a.x - b.x || a.y - b.y);
}
exports.intPointsSet2D = intPointsSet2D;
function pointsToString2D({ pointsArray2D = [] }) {
    return JSON.stringify(pointsArray2D);
}
exports.pointsToString2D = pointsToString2D;
function intRectangle({ xMinInt, xMaxInt, yMinInt, yMaxInt, minWidth, maxWidth, minHeight, maxHeight }) {
    const x = (0, numbers_1.integerBetween)({ minInt: xMinInt, maxInt: xMaxInt });
    const y = (0, numbers_1.integerBetween)({ minInt: yMinInt, maxInt: yMaxInt });
    const width = (0, numbers_1.integerBetween)({ minInt: minWidth, maxInt: maxWidth });
    const height = (0, numbers_1.integerBetween)({ minInt: minHeight, maxInt: maxHeight });
    return {
        x,
        y,
        width,
        height,
        p1: { x, y },
        p2: { x: x + width, y },
        p3: { x: x + width, y: y + height },
        p4: { x, y: y + height },
    };
}
exports.intRectangle = intRectangle;
function intPoint3D({ xMinInt, xMaxInt, yMinInt, yMaxInt, zMinInt, zMaxInt }) {
    const x = (0, numbers_1.integerBetween)({ minInt: xMinInt, maxInt: xMaxInt });
    const y = (0, numbers_1.integerBetween)({ minInt: yMinInt, maxInt: yMaxInt });
    const z = (0, numbers_1.integerBetween)({ minInt: zMinInt, maxInt: zMaxInt });
    return { x, y, z };
}
exports.intPoint3D = intPoint3D;
function intPointsSet3D(props) {
    const { xMinInt, xMaxInt, yMinInt, yMaxInt, zMinInt, zMaxInt, numPoints, areLinked } = props;
    const n = Math.min((xMaxInt - xMinInt + 1) * (yMaxInt - yMinInt + 1) * (zMaxInt - zMinInt + 1), numPoints);
    const points = new Set();
    if (n > 0 && areLinked) {
        points.add({
            x: (0, numbers_1.integerBetween)({ minInt: xMinInt, maxInt: xMaxInt }),
            y: (0, numbers_1.integerBetween)({ minInt: yMinInt, maxInt: yMaxInt }),
            z: 0,
        });
    }
    while (points.size < n) {
        if (areLinked) {
            for (const point of points) {
                if (points.size < n) {
                    const newPoint = Object.assign({}, point);
                    const direction = ['x', 'y', 'z'][Math.floor(Math.random() * 3)];
                    newPoint[direction] += 2 * Math.floor(Math.random() * 2) - 1;
                    if (newPoint[direction] >= props[`${direction}MinInt`] && newPoint[direction] <= props[`${direction}MaxInt`]) {
                        points.add(newPoint);
                    }
                }
            }
        }
        else {
            const point = intPoint3D({ xMinInt, xMaxInt, yMinInt, yMaxInt, zMinInt, zMaxInt });
            if ([...points].findIndex((p) => p.x === point.x && p.y === point.y && p.z === point.z) === -1) {
                points.add(point);
            }
        }
    }
    return [...points].sort((a, b) => a.x - b.x || a.y - b.y || a.z - b.z);
}
exports.intPointsSet3D = intPointsSet3D;
const getElevation = (cubes, projectAxis, flipAxes = [], l = 3, w = 3, h = 3) => {
    const dimensions = { x: l, y: w, z: h };
    return [...new Set([...cubes].map((cube) => {
            const mapped = Object.assign({}, cube);
            if (flipAxes.length && !flipAxes.includes(projectAxis)) {
                for (const axis of flipAxes)
                    mapped[axis] = dimensions[axis] - mapped[axis] - 1;
            }
            delete mapped[projectAxis];
            const values = Object.values(mapped);
            return JSON.stringify({ x: values[0], y: values[1] });
        }))].map((v) => JSON.parse(v)).sort((a, b) => {
        if (a.x > b.x)
            return 1;
        if (a.x < b.x)
            return -1;
        if (a.y > b.y)
            return 1;
        if (a.y < b.y)
            return -1;
        return 0;
    });
};
function elevations(props) {
    const { cubes = [] } = props;
    return {
        front: getElevation(cubes, 'y', ['z']),
        right: getElevation(cubes, 'x', ['y', 'z']),
        top: getElevation(cubes, 'z', []),
    };
}
exports.elevations = elevations;
